const shaka = require('external/shaka-player.ui.debug');

const SkipBackwardButton = class extends shaka.ui.Element {
  constructor(parent: typeof SkipBackwardButton, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = '-10';
    this.button_.classList.add('shaka-skip-backward');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'click', () => {
      this.player.getMediaElement().currentTime -= 10;
    });
  }
};

// Factory that will create a button at run time.
SkipBackwardButton.Factory = class {
  create(rootElement, controls) {
    return new SkipBackwardButton(rootElement, controls);
  }
};

export default SkipBackwardButton;
